import { action, observable } from 'mobx'
import { LocalStorage } from '../../../../../../utilities/LocalStorage'
import { DisplayUnit, GroupByObject, IInventorySummaryFilters } from './types'

export class InventoryLogFilterStore implements IInventorySummaryFilters {
  @observable
  productSearch = ''

  @observable
  selectedCategoryId: string | undefined = undefined

  @observable
  complianceCategoryId: number | undefined = undefined

  @observable
  displayUnit = DisplayUnit.UNITS

  @observable
  groupBy = GroupByObject.CATEGORY

  @observable
  selectedCategoryIds: string[] = []

  @observable
  sku = true

  @observable
  barcode = false

  @observable
  name = true

  @observable
  vendor = false

  @observable
  category = true

  @observable
  complianceCategory = false

  @observable
  cannabisWeight = false

  @observable
  productWeight = false

  @observable
  cannabisVolume = false

  @observable
  openingInventory = true

  @observable
  sold = true

  @observable
  purchased = true

  @observable
  refunded = true

  @observable
  returned = true

  @observable
  lost = true

  @observable
  destroyed = true

  @observable
  transfer = true

  @observable
  audit = true

  @observable
  conversion = true

  @observable
  closingInventory = true

  @observable
  averagePrice = true

  @observable
  averageCost = true

  constructor(private companyId: number) {
    const localStorageFilters = LocalStorage.getInventoryLogFilters()
    if (localStorageFilters && localStorageFilters[this.companyId]) {
      Object.keys(localStorageFilters[this.companyId]).forEach((key) => {
        this[key] = localStorageFilters[this.companyId][key]
      })
    }
  }

  @action
  setProductSearch = (productSearch: string) => {
    this.productSearch = productSearch
  }

  @action
  setSelectedCategoryId = (selectedCategoryId: string | undefined) => {
    this.selectedCategoryId = selectedCategoryId
  }

  @action
  setComplianceCategoryId = (complianceCategoryId: number | undefined) => {
    this.complianceCategoryId = complianceCategoryId
  }

  @action
  setDisplayUnit = (displayUnit: DisplayUnit) => {
    this.displayUnit = displayUnit
    this.syncWithLocalStorage()
  }

  @action
  setGroupBy = (groupBy: GroupByObject) => {
    this.groupBy = groupBy
    this.syncWithLocalStorage()
  }

  @action
  setSelectedCategoryIds = (selectedCategoryIds: string[]) => {
    this.selectedCategoryIds = selectedCategoryIds
    this.syncWithLocalStorage()
  }

  @action
  setSku = (sku: boolean) => {
    this.sku = sku
    this.syncWithLocalStorage()
  }

  @action
  setBarcode = (barcode: boolean) => {
    this.barcode = barcode
    this.syncWithLocalStorage()
  }

  @action
  setName = (name: boolean) => {
    this.name = name
    this.syncWithLocalStorage()
  }

  @action
  setVendor = (vendor: boolean) => {
    this.vendor = vendor
    this.syncWithLocalStorage()
  }

  @action
  setCategory = (category: boolean) => {
    this.category = category
    this.syncWithLocalStorage()
  }

  @action
  setComplianceCategory = (complianceCategory: boolean) => {
    this.complianceCategory = complianceCategory
    this.syncWithLocalStorage()
  }

  @action
  setCannabisWeight = (cannabisWeight: boolean) => {
    this.cannabisWeight = cannabisWeight
    this.syncWithLocalStorage()
  }

  @action
  setProductWeight = (productWeight: boolean) => {
    this.productWeight = productWeight
    this.syncWithLocalStorage()
  }

  @action
  setCannabisVolume = (cannabisVolume: boolean) => {
    this.cannabisVolume = cannabisVolume
    this.syncWithLocalStorage()
  }

  @action
  setOpeningInventory = (openingInventory: boolean) => {
    this.openingInventory = openingInventory
    this.syncWithLocalStorage()
  }

  @action
  setSold = (sold: boolean) => {
    this.sold = sold
    this.syncWithLocalStorage()
  }

  @action
  setPurchased = (purchased: boolean) => {
    this.purchased = purchased
    this.syncWithLocalStorage()
  }

  @action
  setRefunded = (refunded: boolean) => {
    this.refunded = refunded
    this.syncWithLocalStorage()
  }

  @action
  setReturned = (returned: boolean) => {
    this.returned = returned
    this.syncWithLocalStorage()
  }

  @action
  setLost = (lost: boolean) => {
    this.lost = lost
    this.syncWithLocalStorage()
  }

  @action
  setDestroyed = (destroyed: boolean) => {
    this.destroyed = destroyed
    this.syncWithLocalStorage()
  }

  @action
  setTransfer = (transfer: boolean) => {
    this.transfer = transfer
    this.syncWithLocalStorage()
  }

  @action
  setAudit = (audit: boolean) => {
    this.audit = audit
    this.syncWithLocalStorage()
  }

  @action
  setConversion = (conversion: boolean) => {
    this.conversion = conversion
    this.syncWithLocalStorage()
  }

  @action
  setClosingInventory = (closingInventory: boolean) => {
    this.closingInventory = closingInventory
    this.syncWithLocalStorage()
  }

  @action
  setAveragePrice = (averagePrice: boolean) => {
    this.averagePrice = averagePrice
    this.syncWithLocalStorage()
  }

  @action
  setAverageCost = (averageCost: boolean) => {
    this.averageCost = averageCost
    this.syncWithLocalStorage()
  }

  syncWithLocalStorage = () => {
    const filters: IInventorySummaryFilters = {
      productSearch: this.productSearch,
      selectedCategoryId: this.selectedCategoryId,
      complianceCategoryId: this.complianceCategoryId,
      displayUnit: this.displayUnit,
      groupBy: this.groupBy,
      selectedCategoryIds: this.selectedCategoryIds,
      sku: this.sku,
      barcode: this.barcode,
      name: this.name,
      vendor: this.vendor,
      category: this.category,
      complianceCategory: this.complianceCategory,
      cannabisWeight: this.cannabisWeight,
      productWeight: this.productWeight,
      cannabisVolume: this.cannabisVolume,
      openingInventory: this.openingInventory,
      sold: this.sold,
      purchased: this.purchased,
      refunded: this.refunded,
      returned: this.returned,
      lost: this.lost,
      destroyed: this.destroyed,
      transfer: this.transfer,
      audit: this.audit,
      conversion: this.conversion,
      closingInventory: this.closingInventory,
      averagePrice: this.averagePrice,
      averageCost: this.averageCost,
    }

    const localStorageFilters = LocalStorage.getInventoryLogFilters() || {}
    localStorageFilters[this.companyId] = filters
    LocalStorage.setInventoryLogFilters(localStorageFilters)
  }
}
